import Reveal from './Reveal.jsx';

/**
 * The dark green band of oversized figures. The homepage has its own copy in
 * `sections/Numbers.jsx`; this is the version the About and Achievements pages
 * share, where the numbers change but nothing else does.
 */
export default function StatBand({ stats, className = '' }) {
  return (
    <section className={`bg-forest py-14 ${className}`}>
      <div className="mx-auto grid max-w-[1240px] grid-cols-2 gap-x-8 gap-y-10 px-5 sm:px-8 md:grid-cols-4 md:gap-[30px]">
        {stats.map((stat, i) => (
          <Reveal key={stat.value} index={i}>
            <p className="font-display text-[clamp(36px,5.5vw,52px)] font-extrabold leading-none text-sun">
              {stat.value}
            </p>
            <p className="mt-1.5 text-[15px] leading-[1.45] text-sage">{stat.label}</p>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
